<script>
    import estados from '~js/estados';
    import Radio from '~componentes/Radio.vue';
    import { checkbox } from 'vue-strap';
    import converterMoeda from '~js/converter-moeda';

    export default {
        components: { Radio, checkbox },
        props: {
            itemSolicitacao: {
                required: true
            },
            manterObservacao: {
                default: true,
                type: Boolean,
            },
            itensSolicitacaoImportacao: {
                type: Array,
                default: []
            },
            solicitacao: {
                type: Object,
                required: true
            },
            editando: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                estados: estados,
                configuracao: this.$storage.configuracao(),
                tipoItem: '0',
                valorTotalMoeda: 0.0,
                valorTotalReal: 0.0,
            }
        },
        computed: {
            observacaoItemImportacaoContador: function() {
                let quantidadeCaracteres = this.itemSolicitacao.observacaoItemImportacao ?
                    this.itemSolicitacao.observacaoItemImportacao.length : 0;

                return 500 - quantidadeCaracteres;
            },
            retornaSimboloMoeda() {
                if (!this.solicitacao.idMoeda)
                  return '';

                if (this.solicitacao.importacaoMoeda.simbolo)
                    return '(' + this.solicitacao.importacaoMoeda.simbolo + ')';

                return '';
            }
        },
        methods: {
            validar() {
                return this.$validator.validateAll();
            },
            resetarTipo() {
                this.tipoItem = '0';
            },
            limpaDespesasCapital() {
                this.itemSolicitacao.equipamentoComputador = ''
                this.itemSolicitacao.equipamentoMedicaoControle = ''
                this.itemSolicitacao.equipamentoHospitalar = ''
                this.itemSolicitacao.equipamentoMecanicoEletronico = ''
                this.itemSolicitacao.equipamentoOtico = ''
                this.itemSolicitacao.equipamentoOutros = ''
            },
            limpaMaterialConsumo() {
                this.itemSolicitacao.bensConsumoQuimico = ''
                this.itemSolicitacao.bensConsumoPerecivel = ''
                this.itemSolicitacao.bensConsumoEletronico = ''
                this.itemSolicitacao.bensConsumoPecasAcessorios = ''
                this.itemSolicitacao.bensConsumoBiologico = ''
                this.itemSolicitacao.bensConsumoOutros = ''
            },
            limpaServico() {
                this.itemSolicitacao.servicoCongresso = ''
                this.itemSolicitacao.servicoAmostras = ''
                this.itemSolicitacao.servicoEdicaoTexto = ''
                this.itemSolicitacao.servicoPublicacao = ''
                this.itemSolicitacao.servicoSoftware = ''
                this.itemSolicitacao.servicoOutros = ''
            },
            mudarTipoItem() {
                if (this.editando)
                    return;

                this.$validator.reset();

                const codigoItem = document.getElementById("codigoItem");
                codigoItem.removeAttribute('disabled');
                const quantidade = document.getElementById("quantidade");
                quantidade.removeAttribute('disabled');
                const unidade = document.getElementById("unidade");
                unidade.removeAttribute('disabled');
                const nomeFabricante = document.getElementById("nomeFabricante");
                nomeFabricante.removeAttribute('disabled');
                const NCMHSCode = document.getElementById("NCMHSCode");
                NCMHSCode.removeAttribute('disabled');

                this.itemSolicitacao.despesaCapital = false;
                this.itemSolicitacao.servico = false;
                this.itemSolicitacao.materialConsumo = false;
                this.itemSolicitacao.despesaEnvio = false;

                this.itemSolicitacao.quantidade = null;

                switch (this.tipoItem) {
                    case '1':
                        this.itemSolicitacao.despesaCapital = true;
                        this.limpaMaterialConsumo;
                        this.limpaServico;
                        break;
                    case '2':
                        this.itemSolicitacao.materialConsumo = true;
                        this.limpaDespesasCapital;
                        this.limpaServico;
                        break;
                    case '3':
                        this.itemSolicitacao.servico = true;
                        this.itemSolicitacao.quantidade = '1,00';
                        this.itemSolicitacao.unidade = '';
                        this.itemSolicitacao.nomeFabricante = '';
                        this.itemSolicitacao.NCMHSCode = '';
                        this.limpaMaterialConsumo;
                        this.limpaDespesasCapital;
                        break;
                    case '4':
                        this.itemSolicitacao.despesaEnvio = true;
                        this.limpaDespesasCapital;
                        this.limpaMaterialConsumo;
                        this.limpaServico;
                        break;
                    default:
                }
            },
            desabilitarCampos() {
                if (this.itensSolicitacaoImportacao.length == 0)
                    return false
                else {
                    return (this.itensSolicitacaoImportacao[0].servico);
                }
            },
            desabilitarCamposServico() {
                if (this.itensSolicitacaoImportacao.length == 0)
                    return false
                else {

                    return (this.itensSolicitacaoImportacao[0].despesaCapital || this.itensSolicitacaoImportacao[0].materialConsumo);
                }
            },
            calculaValoresTotais() {
                const valorEstimado = this.$options.filters.formatarNumero(this.itemSolicitacao.valorEstimado, true);
                const quantidade = this.$options.filters.formatarNumero(this.itemSolicitacao.quantidade, true);
                let cotacao = this.$options.filters.formatarNumero(this.solicitacao.cotacaoEstimada, true, true,5);     
                
                if (!cotacao)
                    cotacao = 1.0;

                this.valorTotalMoeda = converterMoeda.paraReal(quantidade * valorEstimado);
                this.valorTotalReal = converterMoeda.paraReal(quantidade * valorEstimado * cotacao);
            },
            setarTipo(auxTipo){
                this.tipoItem = auxTipo;
            }
        },
        watch: {
          'tipoItem': 'mudarTipoItem',
          'itemSolicitacao.quantidade': 'calculaValoresTotais',
          'itemSolicitacao.valorEstimado': 'calculaValoresTotais',
          'solicitacao.cotacaoEstimada': 'calculaValoresTotais',
        },
    }
</script>

<template>
    <div>
        <h3 class="m-t m-b">Elemento de Despesa</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <radio v-model="tipoItem"
                           id="despesa"
                           selected-value="1"
                           type="success"
                           :inline="true"
                           :disabled="desabilitarCampos()"
                           class="margin-right-10">
                        Despesa de Capital
                    </radio>
                    <radio v-model="tipoItem"
                           id="material"
                           selected-value="2"
                           type="success"
                           :inline="true"
                           :disabled="desabilitarCampos()"
                           class="margin-right-10">
                        Material de Consumo
                    </radio>
                    <radio v-model="tipoItem"
                           id="servico"
                           selected-value="3"
                           type="success"
                           :disabled="desabilitarCamposServico()"
                           :inline="true"
                           class="margin-right-10">
                        Serviço
                    </radio>
                    <radio v-model="tipoItem"
                           id="despesaEnvio"
                           selected-value="4"
                           type="success"
                           :inline="true">
                        Despesas com Envio
                    </radio>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="row">
            <div v-if="itemSolicitacao.despesaCapital">
                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoComputador" value="1" type="primary">
                                Computador
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoMedicaoControle" value="1" type="primary">
                                Medição e Controle
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoHospitalar" value="1" type="primary">
                                Hospitalar
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoMecanicoEletronico" value="1" type="primary">
                                Mecânico / Eletrônico
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoOtico" value="1" type="primary">
                                Ótico
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.equipamentoOutros" value="1" type="primary">
                                Outros
                            </checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="itemSolicitacao.materialConsumo">
                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoQuimico" value="1" type="primary">
                                Químico
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoPerecivel" value="1" type="primary">
                                Perecível
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoEletronico" value="1" type="primary">
                                Eletrônico
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoPecasAcessorios" value="1" type="primary">
                                Peças e Acessórios
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoBiologico" value="1" type="primary">
                                Biológico
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.bensConsumoOutros" value="1" type="primary">
                                Outros
                            </checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="itemSolicitacao.servico">
                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoCongresso" value="1" type="primary">
                                Congresso
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoAmostras" value="1" type="primary">
                                Amostras
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoEdicaoTexto" value="1" type="primary">
                                Edição de Texto
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoPublicacao" value="1" type="primary">
                                Publicação
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoSoftware" value="1" type="primary">
                                Software
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="itemSolicitacao.servicoOutros" value="1" type="primary">
                                Outros
                            </checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="row">
            <div class="col-xs-6">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Descrição do material/serviço em inglês</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço em inglês">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoTraduzida')}">
                    <label class="control-label" for="descricaoTraduzida">Descrição do material/serviço - traduzida</label>

                    <textarea class="form-control"
                              id="descricaoTraduzida"
                              v-model="itemSolicitacao.descricaoTraduzida"
                              v-validate="'required'"
                              data-vv-name="descricaoTraduzida"
                              data-vv-as="descrição do material/serviço - traduzida">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoTraduzida')">{{ errors.first('descricaoTraduzida') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-2">
                <div class="form-group" :class="{'has-error': errors.has('codigoItem')}">
                    <label class="control-label" for="codigoItem">Código do item</label>

                    <input type="text"
                           class="form-control"
                           id="codigoItem"
                           v-model="itemSolicitacao.codigoItem"
                           data-vv-name="codigoItem"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('codigoItem')">{{ errors.first('codigoItem') }}</p>
                </div>
            </div>

            <div class="col-xs-2">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário {{retornaSimboloMoeda}}</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>

            <div class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
                <div class="form-group" :class="{'has-error': errors.has('valorTotal')}">
                    <label class="control-label" for="valorTotal">Valor total {{retornaSimboloMoeda}}</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valorTotal"
                           v-model="valorTotalMoeda"
                           disabled
                           data-vv-name="valorTotal"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorTotal')">{{ errors.first('valorTotal') }}</p>
                </div>
            </div>

            <div class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
                <div class="form-group" :class="{'has-error': errors.has('cotacaoEstimadaItem')}">
                    <label class="control-label" for="cotacaoEstimadaItem">Cotação estimada</label>

                    <input type="text"
                           class="form-control text-right"
                           id="cotacaoEstimadaItem"
                           v-model="solicitacao.cotacaoEstimada"
                           disabled
                           data-vv-name="cotacaoEstimadaItem">

                    <p class="text-danger" v-show="errors.has('cotacaoEstimadaItem')">{{ errors.first('cotacaoEstimadaItem') }}</p>
                </div>
            </div>

            <div class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
                <div class="form-group" :class="{'has-error': errors.has('valorTotalEstimado')}">
                    <label class="control-label" for="valorTotalEstimado">Valor total estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valorTotalEstimado"
                           v-model="valorTotalReal"
                           disabled
                           data-vv-name="valorTotalEstimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorTotalEstimado')">{{ errors.first('valorTotalEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-2">
                <div class="form-group" :class="{'has-error': errors.has('unidade')}">
                    <label class="control-label" for="unidade">Unidade</label>

                    <input type="text"
                           class="form-control"
                           id="unidade"
                           v-model="itemSolicitacao.unidade"
                           data-vv-name="unidade"
                           maxlength="15">

                    <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
                </div>
            </div>

            <div class="col-xs-2">
                <div class="form-group" :class="{'has-error': errors.has('NCMHSCode')}">
                    <label class="control-label" for="NCMHSCode">NCM ou HS CODE</label>

                    <input type="text"
                           class="form-control"
                           id="NCMHSCode"
                           v-model="itemSolicitacao.ncmhsCode"
                           data-vv-name="NCM ou HS code"
                           maxlength="25">

                    <p class="text-danger" v-show="errors.has('NCMHSCode')">{{ errors.first('NCMHSCode') }}</p>
                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group" :class="{'has-error': errors.has('nomeFabricante')}">
                    <label class="control-label" for="nomeFabricante">Nome fabricante</label>

                    <input type="text"
                           class="form-control"
                           id="nomeFabricante"
                           v-model="itemSolicitacao.nomeFabricante"
                           data-vv-name="nome fabricante"
                           maxlength="35">

                    <p class="text-danger" v-show="errors.has('nomeFabricante')">{{ errors.first('nomeFabricante') }}</p>
                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group" :class="{'has-error': errors.has('paisProcedencia')}">
                    <label class="control-label" for="paisProcedencia">País procedência</label>

                    <input type="text"
                           class="form-control"
                           id="paisProcedencia"
                           v-model="itemSolicitacao.paisProcedencia"
                           data-vv-name="país procedência"
                           maxlength="35">

                    <p class="text-danger" v-show="errors.has('paisProcedencia')">{{ errors.first('paisProcedencia') }}</p>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de importação (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de importação ({{ observacaoItemImportacaoContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemImportacao"
                              maxlength="500">
                    </textarea>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/compartilhado/FormImportacao.vue